import BootstrapDialog from '@/components/Dialog/BootstrapDialog';
import { LeaveConfirmationModal } from '@/components/LeaveConfirmationModal';
import styled from '@emotion/styled';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useWebhookComponentContext } from '../contex';
import { WebhookFormValues } from '../types';
import { parseFormDataToTriggerWebhook } from '../utils/parse-data';
import { ConfigureTabContent } from './ConfigureTabContent';
import { DialogHeader } from './DialogHeader';
import { DialogTabs } from './DialogTabs';
import { TestTabContent } from './TestTabContent';

const StyledBootstrapDialog = styled(BootstrapDialog)`
    display: flex;
    flex-direction: column;

    & .MuiPaper-root {
        padding: 24px;
        min-height: 686px;
    }

    form {
        flex: 1;
        display: flex;
        flex-direction: column;
    }
`;

export const WebhookDialog = () => {
    const { modalOpen, setModalOpen, activeTab, onWebhookSave } = useWebhookComponentContext();
    const { handleSubmit, formState } = useFormContext<WebhookFormValues>();

    const [leaveConfirmationModalOpen, setLeaveConfirmationModalOpen] = useState(false);

    const onSubmit = (data: WebhookFormValues) => {
        const triggerWebhook = parseFormDataToTriggerWebhook(data);
        onWebhookSave(triggerWebhook);

        setModalOpen(false);
    };

    const handleClose = () => {
        if (formState.isDirty || !!Object.keys(formState.dirtyFields).length) {
            setLeaveConfirmationModalOpen(true);
        } else {
            setModalOpen(false);
        }
    };

    const handleConfirm = () => {
        setModalOpen(false);
        setLeaveConfirmationModalOpen(false);
    };

    if (!modalOpen) return null;

    return (
        <>
            <StyledBootstrapDialog open={modalOpen} onClose={handleClose} width="731px">
                <DialogHeader onClose={handleClose} />
                <DialogTabs />

                <form onSubmit={handleSubmit(onSubmit)}>
                    {activeTab === 'configure' && <ConfigureTabContent />}
                    {activeTab === 'test' && <TestTabContent />}
                </form>
            </StyledBootstrapDialog>

            <LeaveConfirmationModal
                open={leaveConfirmationModalOpen}
                onClose={() => setLeaveConfirmationModalOpen(false)}
                onCancel={() => setLeaveConfirmationModalOpen(false)}
                onConfirm={handleConfirm}
                cancelText="No, stay"
                confirmText="Yes, quit"
                message="You have unsaved changes, are you sure you want to quit?"
            />
        </>
    );
};
